import { useFormikContext } from 'formik';
import { useHistory } from 'react-router-dom';

import useSession from 'core/hooks/use-session';
import { useStore } from 'core/store';

/**
 * State and action behind the offer header's "Referred by" control: whether the user can add or
 * change the referrer, whether that's locked behind unsaved form changes, and opening the
 * "Add a referrer" search (from Checkout, after returning to the offer page where it lives).
 * Shared by today's offer header and the Staff Quote Revisit header.
 */
const useEditReferral = ({ fromCheckout, inviter }) => {
  const { viewOnly, isAgency } = useSession();
  const history = useHistory();
  const formikCtx = useFormikContext();
  const {
    offer: store,
    referralSearch: { setSearchString, setShowReferralMatches, searchCustomersAction }
  } = useStore();

  const hasInviter = Boolean(inviter && inviter.firstName && inviter.lastName);
  const dirty = Boolean(formikCtx && formikCtx.dirty);
  const canAddEditReferral = !viewOnly && !isAgency;
  const isLocked = canAddEditReferral && dirty;

  const openReferralSearch = () => {
    if (!canAddEditReferral) {
      return;
    }
    if (fromCheckout) {
      history.push(`/offer/${store.offer.id}`);
    }
    if (hasInviter) {
      setSearchString(`${inviter.firstName} ${inviter.lastName}`);
      searchCustomersAction();
    }
    setShowReferralMatches(true);
  };

  return { hasInviter, dirty, canAddEditReferral, isLocked, openReferralSearch };
};

export default useEditReferral;
